import { render } from "./BetsList.vue?vue&type=template&id=7203e678&scoped=true"
import script from "./BetsList.vue?vue&type=script&lang=js"
export * from "./BetsList.vue?vue&type=script&lang=js"

import "./BetsList.vue?vue&type=style&index=0&id=7203e678&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7203e678"]])

export default __exports__